module.exports = __webpack_public_path__ + "img/2@2x.fe2e1df1.png";